import type { Archive, GameTask } from "./types";
import { canAcceptStar } from "./hunterRank";
export function claimTask(archive: Archive, taskId: string): Archive {
  if (!archive.player.profile.profession.hasHunterLicense)
    throw new Error("该角色没有猎人资格，不能承接公会任务");
  if (archive.tasks.activeTaskId) throw new Error("一次只能承接一个任务");
  const task = archive.tasks.available.find((t) => t.id === taskId);
  if (!task) throw new Error("任务不存在");
  if (!canAcceptStar(archive.player.hunter.hr, task.star))
    throw new Error("猎人资历不足");
  if (archive.player.wallet.zenny < task.contractFee)
    throw new Error("无法支付契约金");
  const next = structuredClone(archive);
  const picked = next.tasks.available.find((t) => t.id === taskId)!;
  picked.status = "active";
  next.tasks.activeTaskId = taskId;
  next.player.wallet.zenny -= picked.contractFee;
  return next;
}
export function abandonTask(archive: Archive): Archive {
  if (!archive.tasks.activeTaskId) return archive;
  const next = structuredClone(archive);
  const i = next.tasks.available.findIndex(
    (t) => t.id === next.tasks.activeTaskId,
  );
  if (i >= 0) {
    const [task] = next.tasks.available.splice(i, 1);
    task.status = "failed";
    next.tasks.history.push(task);
  }
  next.tasks.activeTaskId = null;
  return next;
}
export function completeTaskNarratively(
  archive: Archive,
  taskId: string,
): Archive {
  const next = structuredClone(archive);
  const task = next.tasks.available.find((t) => t.id === taskId);
  if (task && task.status === "active") task.status = "completed";
  return next;
}
export function sanitizeProposedTask(task: GameTask, hr: number): GameTask {
  return {
    ...task,
    status: "available",
    settlementDone: false,
    star: Math.max(1, Math.min(hr + 1, task.star)),
  };
}
